"use client";

import { ZapsEmptyState } from "@zapier/spark-ui";
import { EmptyZapTable } from "./EmptyZapTable";
import { EmptyZapTableTypes } from "./useShowEmptyZapTable";
import "@zapier/spark-ui/style.css";
import styles from "./EmptyZapsState.module.css";

interface Props {
  tableType: EmptyZapTableTypes;
}

export function EmptyZapsState({ tableType }: Props) {
  if (tableType === EmptyZapTableTypes.NoZaps) {
    return (
      <div className={styles.emptyStateWrapper}>
        <div className={styles.gridWrapper}>
          <ZapsEmptyState />
        </div>
      </div>
    );
  }

  return <EmptyZapTable tableType={tableType} />;
}
